import { render, staticRenderFns } from "./JobPostingIcon.vue?vue&type=template&id=35183923"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35183923')) {
      api.createRecord('35183923', component.options)
    } else {
      api.reload('35183923', component.options)
    }
    module.hot.accept("./JobPostingIcon.vue?vue&type=template&id=35183923", function () {
      api.rerender('35183923', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/JobPostingIcon.vue"
export default component.exports